import { yupResolver } from '@hookform/resolvers';
import theme from '@ifca-root/react-component/src/assets/theme';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Grid,
	MenuItem,
	Radio,
	RadioGroup,
	Switch,
	TextField,
	useMediaQuery,
} from '@material-ui/core';
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog';
import AppContext from 'containers/App/Store/AppContext';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	CalcType,
	DiscountType,
	GetDiscountDocument,
	useCreateDiscountMutation,
	useDiscountCreateMutation,
	useDiscountDeleteMutation,
	useDiscountUpdateMutation,
	useGetDiscountQuery,
	useGetMenuItemForDiscountQuery,
	useGetOutletQuery,
	useUpdateDiscountMutation,
} from 'generated/graphql';
import { toProperCase } from 'helpers/hooks/stringNumberFunction/stringConverter';
import { SystemMsgs } from 'helpers/SystemMsg';
import { CommonYupValidation } from 'helpers/yup';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Autocomplete } from '@material-ui/lab';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface DiscountThing {
	code: string;
	description: string;
	amount: number;
	calcType: CalcType;
	discountType: DiscountType;
	isOpenDiscount: boolean;
}

export const DiscountTypeForm = (props: any) => {
	const history = useHistory();
	const { pathname } = useLocation();
	const { outletID }: any = useParams();
	const { discountID }: any = useParams();
	const { mode } = props;
	let location = useLocation();
	let formMode = mode === 'add' ? 'New' : 'Edit';

	const { setOpenSnackBar, setSnackBarMsg } = useContext(
		SnackBarContext as any,
	);

	const [menuItemSelected, setMenuItemSelected] = useState([]);

	const { globalState, dispatch } = useContext(AppContext as any);

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const [OutletDiscount, setOutletDiscount] = useState({
		code: '',
		description: '',
		discountType: '',
		amount: 0,
		calcType: '',
	});

	const [amountNum, setAmount] = useState(0);

	const editData: any = location?.state as any;

	const modApp = mode === 'approve-reject';

	const yupSchema = yup.object().shape({
		code: CommonYupValidation?.requireField(SystemMsgs.title()),
		description: CommonYupValidation?.requireField(SystemMsgs.description()),
		amount: yup
			.string()
			.when('calcType', {
				is: 'PERCENTAGE',
				then: yup.string().required('Percentage is required'),
			})
			.when('calcType', {
				is: 'AMOUNT',
				then: yup.string().required('Amount is required'),
			})
			.nullable(),
	});

	const {
		handleSubmit,
		register,
		setValue,
		watch,
		errors,
		control,
		getValues,
	} = useForm<DiscountThing>({
		mode: 'all',
		defaultValues: {
			code: editData ? editData?.code : '',
			description: editData ? editData?.description : '',
			calcType: editData ? editData?.calcType : '',
			discountType: editData ? editData?.discountType : '',
			amount: editData ? editData?.amount : '',
			isOpenDiscount: editData ? editData?.isOpenDiscount ?? false : false,
		},
		resolver: yupResolver(yupSchema),
	});

	const handleChange = (e: any) => {
		const name = e.target.name;
		const value = e.target.value;
		setOutletDiscount({ ...OutletDiscount, [name]: value });
	};

	const withValueLimit = inputObj => {
		const { value } = inputObj;
		if (watch('calcType') === CalcType.Percentage && value <= 100) {
			return inputObj;
		} else if (watch('calcType') === CalcType.Amount && value > 0) {
			return inputObj;
		}
	};

	const isRetail = JSON.parse(localStorage.getItem('Outlet'))?.isRetail;

	const {
		data: { getMenuItemForDiscount } = { getMenuItemForDiscount: [] },
		loading: getMenuItemForDiscountLoading,
	} = useGetMenuItemForDiscountQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
		},
		onCompleted: ({ getMenuItemForDiscount }) => {
			if (mode === 'edit') {
				let IDs = editData?.discountTypeAssignment?.map(x => x?.menuItemID);

				if (IDs) {
					setMenuItemSelected(
						getMenuItemForDiscount?.filter(x => IDs?.includes(x?.ID)),
					);
				}
			}
		},
	});

	const [
		discountCreate,
		{ loading: createDiscountLoading, error, called: createDiscountCalled },
	] = useDiscountCreateMutation({
		onError: error => {
			console.log('ERROR', error);
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.createNewRecord());
			setTimeout(() => {
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/discount-type`,
					state: { success: true, msgMode: 'create' },
				});
			}, 500);
		},
	});

	const [
		discountUpdate,
		{ called: updateDiscountCalled, loading: updateDiscountLoading },
	] = useDiscountUpdateMutation({
		onError: error => {},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.updateRecord());
			setTimeout(() => {
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/discount-type`,
					state: { success: true, msgMode: 'update' },
				});
			}, 500);
		},
	});

	const createUpdateCalled = editData
		? updateDiscountCalled
		: createDiscountCalled;

	const onSubmit = (data: any) => {
		if (mode == 'add') {
			//add the data with GraphQL mutation
			discountCreate({
				variables: {
					discountInput: {
						code: data.code,
						description: data.description,
						amount: parseFloat(data.amount),
						calcType: data.calcType,
						discountType: data.discountType,
						isOpenDiscount:
							data.calcType === CalcType.Amount ? data.isOpenDiscount : false,
						outletID: outletID,
					},
					outletID: outletID,
					menuItemIDs: menuItemSelected?.map(x => x?.ID),
				},
				refetchQueries: [
					{ query: GetDiscountDocument, variables: { outletID } },
				],
			});
		} else if (mode === 'edit') {
			//update the data
			discountUpdate({
				variables: {
					discountInput: {
						ID: editData?.ID,
						code: data.code,
						description: data.description,
						amount: parseFloat(data.amount),
						calcType: data.calcType,
						discountType: data.discountType,
						isOpenDiscount:
							data.calcType === CalcType.Amount ? data.isOpenDiscount : false,
						outletID: outletID,
					},
					outletID: outletID,
					menuItemIDs: menuItemSelected?.map(x => x?.ID),
				},
				refetchQueries: [
					{ query: GetDiscountDocument, variables: { outletID } },
				],
			});
		}
	};

	const {
		called: outletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});
	const outletArray: any[] = getOutlet;

	const watchValue = watch('amount') != 0 ? watch('amount') : 0;
	const calcType = watch('calcType');
	const isOpenDiscount = watch('isOpenDiscount');
	console.log('aaa', DiscountType.OfficerCheck);

	const discountTypeRename = data => {
		let discountType;
		if (
			data === DiscountType.OfficerCheck &&
			getOutlet[0]?.isRetail === false
		) {
			discountType = 'Officer Check';
		} else if (data === DiscountType.Discount) {
			discountType = 'Discount';
		} else if (
			data === DiscountType.Entertainment &&
			getOutlet[0]?.isRetail === false
		) {
			discountType = 'Entertainment';
		} else if (data === DiscountType.Promo) {
			discountType = 'Promo';
		}

		return discountType;
	};

	useEffect(() => {
		if (calcType !== CalcType.Amount) {
			setValue('isOpenDiscount', false, {
				shouldDirty: true,
				shouldValidate: true,
			});
		}
	}, [calcType, setValue]);

	useEffect(() => {
		console.log('isOpenDiscount state:', isOpenDiscount);
	}, [isOpenDiscount]);
	const [openExitDialog, setOpenExitDialog] = useState(false);

	const filterDiscount = getMenuItemForDiscount.filter(item => {
		const discounts = item.discountTypeAssignment;

		// no discount at all
		if (!discounts || discounts.length === 0) {
			return true;
		}

		// has discount, but allowed discountID
		return discounts.some(d => d.discountID === editData?.ID);
	});

	return (
		<>
			{createDiscountLoading && <Loading />}
			{updateDiscountLoading && <Loading />}
			{getMenuItemForDiscountLoading && <Loading />}

			<MainHeader
				onClick={() => setOpenExitDialog(true)}
				mainBtn="close"
				smTitle={`Outlet App`}
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Outlet Settings' },
					{ name: 'Discount Type', current: true },
				]}
				rightRouteSegments={[
					{ name: mode === 'add' ? 'New' : mode === 'edit' ? 'Edit' : null },
				]}
			/>
			<form onSubmit={handleSubmit(onSubmit)} id="submit-form">
				<ContentWrapper footer>
					<CardContents devFullWidth={true}>
						<Controller
							as={TextField}
							name="code"
							label="Discount Title"
							// required
							autoComplete="off"
							multiline={true}
							margin="normal"
							value={OutletDiscount.code}
							onChange={handleChange}
							control={control}
							ref={register}
							helperText={errors?.code?.message}
							error={!!errors?.code ? true : false}
							required
						/>

						<Controller
							as={TextField}
							name="description"
							label="Description"
							// required
							autoComplete="off"
							multiline={true}
							margin="normal"
							value={OutletDiscount.description}
							onChange={handleChange}
							control={control}
							ref={register}
							helperText={errors?.description?.message}
							error={!!errors?.description ? true : false}
							required
						/>

						<Controller
							as={
								<TextField
									name="discountType"
									defaultValue={editData?.discountType}
								>
									{Object.values(DiscountType)?.map(x => (
										<MenuItem key={x} value={x}>
											{discountTypeRename(x)}
										</MenuItem>
									))}
								</TextField>
							}
							name="discountType"
							margin="normal"
							label="Discount Type"
							fullWidth
							autoComplete="off"
							multiline={true}
							select
							control={control}
							ref={register}
							required
							helperText={errors?.discountType?.message}
							error={errors?.discountType ? true : false}
							// inputRef={register()}
							// defaultValue={editData?.familyID}
						/>

						<FormControl component="fieldset" margin="dense" fullWidth required>
							<Controller
								as={
									<RadioGroup aria-label="VOType">
										<Grid container>
											<Grid item xs={6} className="right">
												<FormControlLabel
													value={CalcType.Percentage}
													name="calcType"
													disabled={mode === 'approve-reject'}
													control={<Radio color="primary" />}
													label="Percentage"
													// ref={register()}
													onChange={() => setValue('amount', 0)}
												/>
											</Grid>
											<Grid item xs={3} className="left">
												<FormControlLabel
													value={CalcType.Amount}
													name="calcType"
													disabled={mode === 'approve-reject'}
													control={<Radio color="primary" />}
													label="Amount"
													// ref={register()}
													onChange={() => {
														setValue('amount', 0);
													}}
												/>
											</Grid>
											{calcType === CalcType.Amount && (
												<Grid item xs={3} className="right">
													<FormControlLabel
														label="Open Discount"
														disabled={mode === 'approve-reject'}
														control={
															<Controller
																name="isOpenDiscount"
																control={control}
																defaultValue={false}
																render={({ value, onChange }) => (
																	<Switch
																		color="primary"
																		checked={!!value}
																		onChange={event => {
																			const checked = event.target.checked;
																			onChange(checked);
																			if (checked) {
																				setValue('amount', 0);
																			}
																		}}
																	/>
																)}
																// as={<Switch  color='primary'/>}
																// onChange= {([event])=>{
																// 	const checked = event.target.checked;

																// 	// setValue('isOpenDiscount',checked);

																// 	if (checked) {
																// 		setValue('amount',0);
																// 	}

																// 	return checked;
																// }}
															/>
														}
													/>
													{/* <Controller
														name='isAmountSwitch'
														control={control}
														defaultValue={false}
														as={
															<FormControlLabel
																label="Open Discount"
																disabled={mode === 'approve-reject'}
																control={<Switch color='primary'/>}	
															/>
														}
														onChange= {([event])=>{
															const checked = event.target.checked;
															
															setValue('isOpenDiscount',checked);

															if (checked) {
																setValue('amount',0);
															}

															return checked;
														}}
													/> */}
												</Grid>
											)}
										</Grid>
									</RadioGroup>
								}
								name="calcType"
								control={control}
								ref={register}
								helperText={errors?.calcType?.message}
								error={errors?.calcType ? true : false}
							/>
							<FormHelperText error={errors?.calcType ? true : false}>
								{errors?.calcType?.message}
							</FormHelperText>
						</FormControl>

						{/* {watch('calcType') && (
							<Controller
								render={({ onChange, onBlur, value }) => (
									<NumberFormat
										allowNegative={false}
										thousandSeparator
										customInput={TextField}
										onValueChange={(value: any) => {
											const { floatValue } = value;
											onChange(floatValue);
										}}
										decimalScale={
											watch('calcType') === CalcType.Amount ? 2 : ''
										}
										label={
											watch('calcType') === CalcType.Amount
												? 'Amount'
												: 'Percentage (%)'
										}
									/>
								)}
								id="standard-basic"
								name="amount"
								helperText={errors?.amount?.message}
								error={errors?.amount ? true : false}
								autoComplete="off"
								control={control}
								fixedDecimalScale
								margin="dense"
								required
                // value={OutletDiscount.amount}
							  // onChange={handleChange}
                // defaultValue={editData ? editData?.description : ''}
								ref={register}
								disabled={formMode === 'approve-reject' ? true : false}
							/>
						)} */}

						{watch('calcType') && (
							<Controller
								as={
									<NumberFormat
										customInput={TextField}
										allowNegative={false}
										fullWidth
										autoComplete="off"
										isNumericString
										decimalScale={
											watch('calcType') === CalcType.Amount ? 2 : null
										}
										fixedDecimalScale
										onValueChange={(value: any) => {
											const { floatValue } = value;
										}}
									/>
								}
								name="amount"
								label={
									watch('calcType') === CalcType.Amount
										? 'Amount'
										: 'Percentage (%)'
								}
								control={control}
								ref={register}
								defaultValue={editData ? editData?.amount : ''}
							/>
						)}
					</CardContents>

					{isRetail && (
						<CardContents
							section={{
								header: {
									title: 'Menu Item Assignment',
								},
							}}
						>
							<Autocomplete
								multiple
								options={filterDiscount}
								disableCloseOnSelect
								fullWidth
								size="small"
								groupBy={option =>
									`${option?.major?.name} - ${option?.family?.name}` || ''
								}
								getOptionLabel={option => option?.name}
								renderOption={(option, { selected }) => (
									<React.Fragment>
										<Checkbox
											icon={icon}
											checkedIcon={checkedIcon}
											style={{ marginRight: 8 }}
											checked={selected}
											color="primary"
										/>
										{option.name}
									</React.Fragment>
								)}
								value={menuItemSelected}
								onChange={(_, value) => {
									setMenuItemSelected(value);
								}}
								renderInput={params => (
									<TextField
										{...params}
										variant="outlined"
										fullWidth
										label="Menu Item"
										placeholder="Search here..."
										margin="normal"
									/>
								)}
							/>
						</CardContents>
					)}
				</ContentWrapper>
			</form>

			<DynamicFooter
				style={{
					width:
						isDesktop && globalState.drawerOpen ? 'calc(100% - 240px)' : '100%',
				}}
				options={[
					{
						name: 'Save',
						color: 'primary',
						props: {
							color:
								watchValue === 0 || watchValue === undefined
									? 'inherit'
									: 'primary',
							type: 'submit',
							disabled: watchValue === 0 ? true : false,
						},
						onClick: () => {
							handleSubmit(data => !createUpdateCalled && onSubmit(data))();
						},
					},
				]}
			/>

			<ExitConfirmationDialog
				openExitDialog={openExitDialog}
				setOpenExitDialog={setOpenExitDialog}
				backPath={`/menu/outlet-app/outlet-setting/${outletID}/discount-type`}
			/>
		</>
	);
};
